import component from './index';

import less from '!raw-loader!./index.less';
import templateStr from '!raw-loader!./index';

export default {
  component,
  templateStr,
  less,
  dataSource: {
    wrapper: {
      className: 'home-page-wrapper feature10',
    },
    page: {
      className: 'home-page feature10-page',
    },
    content: {
      className: 'feature10-content',
      playScale: 0.3,
      always: false,
      left: {
        className: 'feature10-content-left',
        children: [
          {
            name: 'title0',
            className: 'feature10-content-left-title0',
            children: '<strong style="font-size:.2rem;">龙泉驿</strong>作为成都<strong style="font-size:.2rem;">“东进”桥头堡</strong>，</br>成渝相向发展主战场，是成都承西启东的主要枢纽',
          },
          {
            name: 'title1',
            className: 'feature10-content-left-title1',
            children: '成都是“一带一路”倡议的战略支点城市，是国家全面创新改革、西部大开发、成渝地区双城经济圈战略等的战略实施地。',
          },
        ],
      },
      right: {
        className: 'feature10-content-right',
        children: 'https://imm.86links.com/assets/landing/images/%E4%BD%8D%E5%9B%BE%402x(5).png',
      },

    },

  },
};
